import { Controller } from "@hotwired/stimulus"
import Swiper from 'swiper/bundle'

// Connects to data-controller="swiper"
export default class extends Controller {

  static values = {
    config: String
  }

  connect() {
    const swiperConfig = this.getSwiperConfig();
    this.swiper = new Swiper(this.element, swiperConfig);
  }

  disconnect() {
    if (this.swiper) {
      this.swiper.destroy();
    }
  }

  getSwiperConfig() {
    const configName = this.configValue || "default";

    const baseConfig = {
      slidesPerView: 1.5,
      autoHeight: false,
      spaceBetween: 24,
      loop: false,
      watchSlidesProgress: true,
      navigation: {
        enabled: false,
        prevEl: ".swiper-button-prev",
        nextEl: ".swiper-button-next",
      },
      pagination: {
        enabled: false
      },
      breakpointsBase: 'window'
    };

    const configurations = {
      default: {
        ...baseConfig,
        creativeEffect: {
          limitProgress: 5,
          prev: { shadow: true },
          next: { shadow: true },
        },
        lazy: { enabled: true },
        breakpoints: {
          768: { slidesPerView: 2, navigation: { enabled: true } },
          1200: { slidesPerView: 3, navigation: { enabled: true } }
        }
      },

      configGallery: {
        ...baseConfig,
        breakpoints: {
          768: { slidesPerView: 2, navigation: { enabled: true } },
          992: { slidesPerView: 2, navigation: { enabled: true } },
          1200: {
            slidesPerView: 3,
            navigation: { enabled: true },
            effect: "coverflow",
            coverflowEffect: {
              slideShadows: false,
              rotate: 0,
              depth: 0,
              scale: 0.9
            },
          }
        }
      },

      configCoreValues: {
        ...baseConfig,
        slidesPerView: 1,
        autoplay: { enabled: true, pauseOnMouseEnter: true },
        on: {
          init: (swiper) => {
            const bullets = document.querySelectorAll('.core-values-pagination .bullet');
            bullets.forEach((bullet, index) => {
              bullet.addEventListener('click', () => swiper.slideTo(index));
            });
            bullets[0]?.classList.add('active');
          },
          slideChange: (swiper) => {
            const bullets = document.querySelectorAll('.core-values-pagination .bullet');
            bullets.forEach((bullet, index) => {
              bullet.classList.toggle('active', index === swiper.activeIndex);
            });
          }
        }
      },

      configCol3: {
        ...baseConfig,
        breakpoints: {
          768: { slidesPerView: 2, navigation: { enabled: true } },
          992: { slidesPerView: 3, navigation: { enabled: true } },
          1200: { slidesPerView: 3, navigation: { enabled: true } }
        }
      },

      configCol4: {
        ...baseConfig,
        breakpoints: {
          768: { slidesPerView: 2, navigation: { enabled: true } },
          992: { slidesPerView: 3, navigation: { enabled: true } },
          1200: { slidesPerView: 4, navigation: { enabled: true } }
        }
      },

      configCol5: {
        ...baseConfig,
        slidesPerView: 1.5,
        breakpoints: {
          768: { slidesPerView: 3, navigation: { enabled: true } },
          992: { slidesPerView: 4, navigation: { enabled: true } },
          1200: { slidesPerView: 5, navigation: { enabled: true } }
        }
      },

      configCol6: {
        ...baseConfig,
        slidesPerView: 2.5,
        breakpoints: {
          768: { slidesPerView: 3, navigation: { enabled: true } },
          992: { slidesPerView: 4, navigation: { enabled: true } },
          1200: { slidesPerView: 5, navigation: { enabled: true } },
          1400: { slidesPerView: 6, navigation: { enabled: true } }
        }
      }
    }

    return configurations[configName] || configurations.default;

  }
}
